import apiRequest from './client';

const toQuery = (params) => {
  const qs = Object.entries(params)
    .filter(([, v]) => v !== undefined && v !== null && v !== '')
    .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
    .join('&');
  return qs ? `?${qs}` : '';
};

export const fetchSalesMonitoringSummary = ({ tirage, date, filter, scope }) =>
  apiRequest(`/tickets/sales-monitoring/summary/${toQuery({ tirage, date, filter, scope })}`);

// Suivi Express : ventes du jour de TOUTES les loteries, séparées par loterie.
// -> { date, by_tirage: [{ tirage_code, tirage_name, numbers[], product_summary[],
//      total_value, total_bets }], lottery_summary: [{ lot, desc, local, online, total }] }
export const fetchExpressMonitoring = ({ date, filter, scope } = {}) =>
  apiRequest(`/tickets/sales-monitoring/express/${toQuery({ date, filter, scope })}`);

export const fetchMoveDetail = ({ tirage, date, product, numbers, filter, scope }) =>
  apiRequest(`/tickets/sales-monitoring/move-detail/${toQuery({ tirage, date, product, numbers, filter, scope })}`);

export const fetchTicketsPerBank = ({ tirage, date, product, numbers, bank }) =>
  apiRequest(`/tickets/sales-monitoring/tickets-per-bank/${toQuery({ tirage, date, product, numbers, bank })}`);

export const fetchTicketDetail = (ticketId) =>
  apiRequest(`/tickets/sales-monitoring/ticket-detail/${ticketId}/`);
